import { render } from "./Panel.vue?vue&type=template&id=42747329&scoped=true&ts=true"
import script from "./Panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Panel.vue?vue&type=script&setup=true&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=42747329&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42747329"],['__file',"resources/js/components/ui/panel/Panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42747329"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42747329', __exports__)) {
    console.log('reload')
    api.reload('42747329', __exports__)
  }
  
  module.hot.accept("./Panel.vue?vue&type=template&id=42747329&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('42747329', render)
  })

}


export default __exports__